import {Heading, Link} from '@constellation/core';
import {memo} from 'react';
import {type cardPaymentProps} from '../../../../../types/cardPaymentServiceDetails.js';
import breakPoint from '../../../../../utils/breakPoint.js';
import {CARD_PAYMENTS} from '../../../../../utils/constants/public/psr.js';
import {getPsrLabel} from '../../../../../utils/index.js';
import {getQuotationPrice} from '../../../../../utils/quotation.js';
import {
  TransactionChargesDiv,
  TransactionFeeLabel,
  TransactionFeeValue,
  TransactionHeading,
} from '../Styles/Styles.js';
import TransactionChargesLargeScreen from './TransactionChargesLargeScreen.js';
import TransactionChargesSmallScreen from './TransactionChargesSmallScreen.js';

const TransactionCharges = memo((props: cardPaymentProps) => {
  const schemeRates = props.quoteResponse?.quote?.schemeRates;
  const authorisationFee =
    props.quoteResponse?.quote?.otherTransactionFees?.authorisationFee;
  const chargeBackFee =
    props.quoteResponse?.quote?.otherTransactionFees?.chargeBackFee;
  const revivalFee =
    props.quoteResponse?.quote?.otherTransactionFees?.revivalFee;

  return (
    <TransactionChargesDiv marginBottom='none'>
      <Heading as='h2' size='s3'>
        <div id={CARD_PAYMENTS}>
          {getPsrLabel(
            'cardPaymentServicesDetails.transactionCharges.cardPaymentsCharges.labelText'
          )}
          <small>
            <sup>
              <Link
                aria-label={`footnote ${getPsrLabel(
                  'cardPaymentServicesDetails.transactionCharges.cardPaymentsCharges.labelTextRef'
                )}`}
                href='#mostcommonusedcard'
                id={`mostcommonusedcard-ref${breakPoint}`}
              >
                {getPsrLabel(
                  'cardPaymentServicesDetails.transactionCharges.cardPaymentsCharges.labelTextRef'
                )}
              </Link>
            </sup>
          </small>
        </div>
      </Heading>
      <TransactionChargesSmallScreen
        authorisationFee={authorisationFee}
        schemeRates={schemeRates}
      />
      <TransactionChargesLargeScreen
        authorisationFee={authorisationFee}
        schemeRates={schemeRates}
      />
      <TransactionHeading marginBottom='03' size='s3' weight='bold'>
        {getPsrLabel(
          'cardPaymentServicesDetails.transactionCharges.otherCharges.labelText'
        )}
      </TransactionHeading>
      <TransactionFeeLabel>
        {getPsrLabel(
          'cardPaymentServicesDetails.transactionCharges.otherCharges.feeLabel1'
        )}
      </TransactionFeeLabel>
      <TransactionFeeValue
        aria-label={
          chargeBackFee?.value
            ? `'${chargeBackFee?.value}'`
            : getPsrLabel('cardPaymentServicesDetails.naFullForm')
        }
        role='textbox'
      >
        <span aria-hidden={true}>
          {getQuotationPrice(chargeBackFee?.value, true)}
        </span>
      </TransactionFeeValue>
      <TransactionFeeLabel>
        {getPsrLabel(
          'cardPaymentServicesDetails.transactionCharges.otherCharges.feeLabel2'
        )}
      </TransactionFeeLabel>
      <TransactionFeeValue
        aria-label={
          revivalFee?.applicable
            ? `'${revivalFee?.value}'`
            : getPsrLabel('cardPaymentServicesDetails.naFullForm')
        }
        role='textbox'
      >
        <span aria-hidden={true}>
          {getQuotationPrice(revivalFee?.value, revivalFee?.applicable)}
        </span>
      </TransactionFeeValue>
    </TransactionChargesDiv>
  );
});

export default TransactionCharges;
